module.exports = __webpack_public_path__ + "static/media/trophy-alt.c6afb700.svg";